import type { EnvironmentClassEntry } from "@/hooks/use-environment-class-entries";
import { RunnerKind, RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";

// localEnvType is a "special" environment type for projects that represents local runners.
export const localEnvType: EnvironmentClassEntry = {
    clazz: {
        enabled: true,
        id: "local",
        description: "Local",
        displayName: "Ona Desktop",
        analyticsName: "Ona Desktop - Linux App",
        runnerId: "local",
        configuration: [],
    },
    runner: {
        status: {
            phase: RunnerPhase.ACTIVE,
            version: "",
            systemDetails: "",
            logUrl: "",
            additionalInfo: [],
            message: "",
            region: "",
            capabilities: [],
            llmUrl: "",
            publicKey: new Uint8Array(0),
            supportBundleUrl: "",
        },
        runnerId: "local",
        name: "",
        kind: RunnerKind.LOCAL,
        provider: RunnerProvider.DESKTOP_MAC,
        runnerManagerId: "",
    },
    localRunner: true,
    policyRestricted: false,
} as const;
